// ** Auth Endpoints
export default {
  loginEndpoint: 'https://api.yehey.jp/auth/cargoV2/admin/session',
  registerEndpoint: 'https://api.yehey.jp/auth/cargoV2/admin/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
